module.exports = __webpack_public_path__ + "static/media/logo.f20c322c.png";


//////////////////
// WEBPACK FOOTER
// ./src/contents/images/logo.png
// module id = 341
// module chunks = 0